<nav class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="container-fluid">
        <div class="logo">
            <a routerLink="/"><h3 class="name-project">CityDiscovery</h3></a>
        </div>

        <button
            class="navbar-toggler"
            type="button"
            aria-expanded="false"
            aria-label="Toggle navigation"
            (click)="openNav()"
        >
            <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarSupportedContent" [ngClass]="{'show': isOpen}">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a href="" class="nav-link">{{ "Home" | translate }}</a>
                </li>
                <li class="nav-item">
                    <a href="#blog" class="nav-link">{{
                        "Quest" | translate
                    }}</a>
                </li>
                <li class="nav-item">
                    <a href="#about" class="nav-link">{{
                        "About" | translate
                    }}</a>
                </li>
                <li class="nav-item">
                    <a href="#features" class="nav-link">{{
                        "Features" | translate
                    }}</a>
                </li>
                <li class="nav-item">
                    <a href="#faq" class="nav-link">{{ "FAQ" | translate }}</a>
                </li>
                <li class="nav-item">
                    <a href="#contact" class="nav-link">{{
                        "Contact" | translate
                    }}</a>
                </li>
                <!-- <li class="nav-item language">
                    <select
                        class="form-select form-select-lg"
                        (change)="changeLang($event)"
                    >
                        <option value="vi-VN" [selected]="langNumber == 1">
                            Tiếng Việt
                        </option>
                        <option value="en-US" [selected]="langNumber == 0">
                            English
                        </option>
                    </select>
                </li> -->
            </ul>
            <div class="language">
                <select
                    class="form-select form-select-lg"
                    (change)="changeLang($event)"

                >
                    <option value="vi-VN" [selected]="langNumber == 1">
                        Tiếng Việt
                    </option>
                    <option value="en-US" [selected]="langNumber == 0">
                        English
                    </option>
                </select>
            </div>
            <!-- <div class="switch">
                <label class="switch__wrapper">
                  <input type="checkbox" (change)="changeLang($event)"/>
                  <span class="switch__slider"></span>
                  <div></div>
                </label>
            </div> -->

            <div class="others-option" *ngIf="sessionLogin === null">
                <div class="d-flex align-items-center">
                    <div class="option-item">
                        <!-- <a routerLink="/" class="default-btn">{{ 'nav_btn_download' | translate }} <span></span></a> -->
                        <a
                            (click)="openVerticallyCentered()"
                            class="default-btn"
                        >
                            {{'btn_login' | translate}} <span></span
                        ></a>
                    </div>
                </div>
            </div>
            <div class="others-option pt-2" *ngIf="sessionLogin !== null">
                <div class="d-flex align-items-center">
                    <div class="option-item">
                        <div ngbDropdown class="d-inline-block">
                            <!-- <button type="button" class="btn btn-outline-primary" id="dropdownBasic1" ngbDropdownToggle>Toggle dropdown</button> -->
                            <img
                                id="dropdownBasic1"
                                ngbDropdownToggle
                                src="{{ customer?.imagePath == null ? 'assets/img/default-avatar.png': customer?.imagePath}}"
                                class="avatar"
                                alt="image"
                            />

                            <div
                                ngbDropdownMenu
                                aria-labelledby="dropdownBasic1"
                            >
                                <button ngbDropdownItem (click)="manageAccount()"> {{'setting' | translate}} </button>
                                <button ngbDropdownItem (click)="logout()"> {{'btn_logout' | translate}} </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</nav>

<!-- Modal -->
